import { Summary } from '@cfpb/cfpb-design-system/src/index.js';
Summary.init();
